import { render } from "./AIPromptModal.vue?vue&type=template&id=9490178a"
import script from "./AIPromptModal.vue?vue&type=script&lang=js"
export * from "./AIPromptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__